module.exports = __webpack_public_path__ + "img/intro-4.bfff36c0.jpg";